export const reducedModeEnabled = (import.meta.env.VITE_REDUCED_MODE ?? 'true') !== 'false';

export const reducedModeYouTubeApiKey = (import.meta.env.VITE_YOUTUBE_API_KEY ?? '').trim();

export const reducedModeYouTubeEnabled = reducedModeEnabled && reducedModeYouTubeApiKey.length > 0;

export const reducedModeMessage =
  'QrOke keeps party creation, QR joining, queueing, and lightweight song search front and center so karaoke nights start quickly and stay easy to run.';

export const reducedModeHighlights = ['Fast party launch', 'Guest QR join', 'Lean queue flow'];
